_ = require 'underscore'
BaseDirectoryView = require './base-directory-view'
DirectoryPluginItemView = require './directory-plugin-item-view'
t = require('views/internal/recup-with-helpers')('directory_home')
React = require 'react'
$ = require 'jquery'

class DirectoryHomeComponent extends React.Component
  displayName: 'Directory Home'

  render: t.renderable ->
    t.div ->
      t.div '.directory-content-body', ->
        t.div '.directory-heading-wrapper', ->
          t.h2 ->
            t.formatText 'featured-power-ups'
        t.div '.directory-featured-powerups.js-featured-power-ups-container'
        t.div '.directory-heading-wrapper', ->
          t.h2 ->
            t.formatText 'essential-power-ups'
        t.div '.directory-featured-powerups.js-essential-power-ups-container'
        t.div '.directory-heading-wrapper', ->
          t.h2 ->
            t.formatText 'other-great-power-ups'
        t.div '.directory-featured-powerups.js-other-power-ups-container'

module.exports = class DirectoryHomeView extends BaseDirectoryView

  initialize: ({ @directoryView, currentPage }) ->
    super

  renderContent: ->
    React.createElement DirectoryHomeComponent

  getPluginsByTags: (tags) ->
    return _.filter(@directoryView.plugins, (plugin) ->
      return _.every(tags, (tag) ->
        _.contains(plugin.get('tags'), tag)
      )
    )

  getFeaturedPlugins: ->
    @featuredPlugins ?= @getPluginsByTags(['featured'])

  getEssentialPlugins: ->
    @essentialPlugins ?= @getPluginsByTags(['essential'])

  getOtherPowerUps: ->
    excludeFeaturedAndEssential = _.filter(@directoryView.plugins, (plugin) ->
      return !_.contains(plugin.get('tags'), 'featured') &&
        !_.contains(plugin.get('tags'), 'essential')
    )
    return _.sample(excludeFeaturedAndEssential, 12)

  render: ->
    super

    featuredPluginItemSubviews = _.map(
      @directoryView.filterOutHiddenPlugins(@getFeaturedPlugins()),
      (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: 'featured'
          @currentPage
          plugin
          @directoryView
        }, plugin.id)
    )

    essentialPluginItemSubviews = _.map(
      @directoryView.filterOutHiddenPlugins(@getEssentialPlugins()),
      (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: 'featured'
          @currentPage
          plugin
          @directoryView
        }, plugin.id)
    )

    otherPluginItemSubviews = _.map(
      @getOtherPowerUps(),
      (plugin) =>
        @subview(DirectoryPluginItemView, @model, {
          atomType: 'description'
          @currentPage
          plugin
          @directoryView
        }, plugin.id)
    )

    @appendSubviews(featuredPluginItemSubviews, @$el.find('.js-featured-power-ups-container'))
    @appendSubviews(essentialPluginItemSubviews, @$el.find('.js-essential-power-ups-container'))
    @appendSubviews(otherPluginItemSubviews, @$el.find('.js-other-power-ups-container'))

    @



// WEBPACK FOOTER //
// ./app/scripts/views/directory/directory-home-view.coffee